import http from './http';

export interface Country {
  id: number;
  code: string;
  name: string;
}
export interface Province {
  id: number;
  code: string;
  name: string;
  countryId: number;
}
export interface District {
  id: number;
  name: string;
  provinceId: number;
}
export interface Ward {
  id: number;
  name: string;
  districtId: number;
}

export const addressApi = {
  getCountries: () => http.get<{ total: number; data: Country[] }>('/addresses/countries').then((r) => r.data.data),

  getProvinces: (countryId: number) => http.get<{ total: number; data: Province[] }>(`/addresses/provinces/${countryId}`).then((r) => r.data.data),

  getDistricts: (provinceId: number) => http.get<{ total: number; data: District[] }>(`/addresses/districts/${provinceId}`).then((r) => r.data.data),

  getWards: (districtId: number) => http.get<{ total: number; data: Ward[] }>(`/addresses/wards/${districtId}`).then((r) => r.data.data),
};
